import Recipients      from './collection-recipients';
import RecipientGroup  from './model-recipientGroup';
import { defa }        from '../../../defa-object';
import RecipientGroups from './collection-recipientGroups'
import Model           from '../../poppet/model';

/**
 * defa.models.recipientGroupHolder
 * The DEFA RecipientGroupHolder model.
 * A model which holds all RecipienGroups for each unit
 * @version 1.0.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	unitUrl: apiHost + '/units/',
	recipientGroups: '/notificationgroups',
};

const RecipientGroupHolder = Model.extend( {
	
	url: function ( ) {
		return api.unitUrl + this.get('id') + api.recipientGroups;
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: {
		recipientGroups: [],
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	/**
	 * Parses incoming data before creating the model.
	 * @param  {object} response  The response from the server.
	 * @overwrite
	 */
	parse:function(response){
		if( response ) {
			let groups = [];
			for(let index in response){
				let group = response[index];
				let recipients = new Recipients(group.notificationRecipients);
				group.notificationRecipients = recipients;
				groups.push(new RecipientGroup(group));
			}
			this.set( { recipientGroups: new RecipientGroups(groups)} );
			channel.request( 'recipientGroupHolders' ).add( this, { merge: true } );
		}
	}

	
});

export default RecipientGroupHolder;